import { css, cva } from '@/styled-system/css';
import { shimmerStyles } from '@zg-rentals/loading-components';

export const containerStyles = css.raw({
  background: 'white',
  borderBottom: '1px solid {colors.border.subtle}',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const contentContainerStyles = css.raw({
  display: 'flex',
  flex: 1,
  flexDirection: { base: 'column', lg: 'row' },
  padding: { base: '{spacing.200} 0', lg: '{spacing.400} {spacing.200}' },
  textAlign: 'left',
});

export const photoContainerStyles = css.raw({
  ...shimmerStyles,
  borderRadius: '100',
  height: { base: '168px', lg: '124px' },
  width: { base: '100%', lg: '124px' },
  marginBottom: { base: '200', lg: '0' },
  marginRight: { lg: '600' },
});

export const flexStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  minWidth: '0',
  width: '100%',
});

export const streetTextStyles = css.raw({
  textStyle: 'heading-xs',
  lineHeight: '26px',
  maxWidth: { base: '100%', lg: '500px' },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const cityStateStyles = css.raw({
  textStyle: 'body-sm-bold',
  lineHeight: { base: '18px', lg: '24px' },
  maxWidth: { base: '100%', lg: '500px' },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const feedSourceStyles = css.raw({
  textStyle: 'body-sm-bold',
  lineHeight: { base: '18px', lg: '24px' },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: { lg: '33%' },
  // eslint-disable-next-line curly-quotes/no-straight-quotes
  _after: { lg: { content: '"\\00a0"' } },
});

export const emailTextStyles = cva({
  base: {
    textStyle: 'body-sm',
    lineHeight: { base: '18px', lg: '24px' },
    maxWidth: { base: '100%', lg: '40%' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line curly-quotes/no-straight-quotes
    _before: { lg: { content: '"\\2022\\00a0"' } },
    // eslint-disable-next-line curly-quotes/no-straight-quotes
    _after: { lg: { content: '"\\00a0"' } },
  },
  variants: {
    highlight: {
      true: {
        fontWeight: 'bold',
      },
      false: {
        fontWeight: 'normal',
      },
    },
  },
});

export const phoneTextStyles = cva({
  base: {
    textStyle: 'body-sm',
    lineHeight: { base: '18px', lg: '24px' },
    maxWidth: { lg: '33%' },
    // eslint-disable-next-line curly-quotes/no-straight-quotes
    _before: { lg: { content: '"\\2022\\00a0"' } },
  },
  variants: {
    highlight: {
      true: {
        fontWeight: 'bold',
      },
      false: {
        fontWeight: 'normal',
      },
    },
  },
});
